import React from 'react';

import PageContent from 'components/PageContent';
import CurrencyConverter from 'components/CurrencyConverter';
import { CardsAverageTable } from 'components/CardsAverageTable';
import ExchangeDiscussion from 'components/ExchangeDiscussion';
import NewsSlider from 'components/NewsSlider';
import CurrencyNews from 'components/CurrencyNews';
import BanksTable from 'components/BanksTable';
import { NUMBER_OFF_ALL_ORGANIZATIONS } from 'constants/organizations';

const CardsPageContent = () => {
  return (
    <PageContent>
      <CardsAverageTable cardType="all" hasSubTitle />
      <BanksTable
        quantity={NUMBER_OFF_ALL_ORGANIZATIONS}
        title="table.banks.mainTitle.cards"
        hasCashColumn={false}
      />
      <CurrencyConverter />
      <CardsAverageTable cardType="visa" />
      <CardsAverageTable cardType="mc" />
      <ExchangeDiscussion />
      <NewsSlider />
      <CurrencyNews />
    </PageContent>
  );
};

export default CardsPageContent;
